module.exports = __webpack_public_path__ + "static/note-whoseinterface-do-12c7bbce953b318d6d45400eca2af6b5.png";